import { useTranslation } from 'react-i18next';
import { Location } from '../../../stores/types';
import { WarningMessage } from '../../_ui/WarningMessage';
import { NoPowerManaged } from '../NoPowerManaged';
import LocationDetails from './LocationDetails.component';

interface LocationWoPowerManagementProps {
  locations: Location[];
  data: string[];
  showWarning: Function;
}

export const LocationWoPowerManagement = ({
  locations,
  data,
  showWarning,
}: LocationWoPowerManagementProps) => {
  const { t } = useTranslation();

  if (!data?.length) return <NoPowerManaged isWithLocation />;

  const getLocationById = (id: string) =>
    locations.find((location) => location.id === id);

  return (
    <div data-testid='locationsWithoutPm' className='flex flex-col gap-4'>
      <WarningMessage text={t('locations_without_chargers_warning')} />
      {data.map((ele: string) => {
        const locationData = getLocationById(ele);
        return locationData ? (
          <LocationDetails location={locationData} showWarning={showWarning} />
        ) : null;
      })}
    </div>
  );
};
